import round from 'lodash/round';
import { pxToRem } from '../helpers/rem';
/** In px */
const BASE_SPACING = 12;
const getSpacingEntry = (factor) => {
    const result = BASE_SPACING * factor;
    const rounded = round(result, 2);
    return rounded;
};
const spacingMap = {
    '0': 0,
    '1/4': getSpacingEntry(1 / 4),
    '1/2': getSpacingEntry(1 / 2),
    '3/4': getSpacingEntry(3 / 4),
    '1': getSpacingEntry(1),
    '3/2': getSpacingEntry(1.5),
    '2': getSpacingEntry(2),
};
export const getSpacing = (spacing) => {
    const spacingWithoutTrue = spacing === true ? '1' : spacing;
    const spacingWithoutFalse = spacingWithoutTrue === false ? '0' : spacingWithoutTrue;
    const spacingWithoutUndefined = spacingWithoutFalse ?? '1';
    const pxSpacing = spacingMap[spacingWithoutUndefined];
    const remSpacing = pxToRem(pxSpacing);
    return remSpacing;
};
